import cx from 'classnames';

import type { CardProps } from './Card.types';
import { CardDensity } from './Card.types';

const Card = ({ density = CardDensity.default, children, className, id, backgroundColor = 'bg-white' }: CardProps) => {
  const densityClass = {
    default: 'p-6',
    compact: 'p-4',
    wide: 'p-10',
  }[density];

  return (
    <div id={id} className={cx('border-surface-200 rounded-md border', backgroundColor, densityClass, className)}>
      {children}
    </div>
  );
};

export default Card;
